webpackJsonp([3],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _adLoader = __webpack_require__(21);
	
	var _adLoader2 = _interopRequireDefault(_adLoader);
	
	var _preact = __webpack_require__(1);
	
	var _app = __webpack_require__(22);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _preact.render)((0, _preact.h)(_app2.default, null), document.getElementById('app'));
	
	(0, _adLoader2.default)();

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var Countdown = function Countdown(_ref) {
	  var noLine = _ref.noLine,
	      alignment = _ref.alignment,
	      _ref$timeLeft = _ref.timeLeft,
	      timeLeft = _ref$timeLeft === undefined ? '--' : _ref$timeLeft;
	
	  var klass = 'countdown';
	  var timeLeftIsNumber = typeof timeLeft === 'number' && isFinite(timeLeft);
	
	  if (alignment === 'center') {
	    klass += ' countdown--center';
	  }
	
	  if (noLine) {
	    klass += ' countdown--noline';
	  }
	
	  var output = null;
	
	  if (timeLeft === '--') {
	    output = 'Next update in ' + timeLeft;
	  } else if (timeLeftIsNumber) {
	    output = 'Next update in :' + timeLeft;
	  } else if (timeLeft === 'Updating!') {
	    output = timeLeft;
	  }
	  return (0, _preact.h)(
	    'div',
	    { className: klass },
	    output
	  );
	};
	
	exports.default = Countdown;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _formatPercent = __webpack_require__(9);
	
	var _formatPercent2 = _interopRequireDefault(_formatPercent);
	
	var _numberWithCommas = __webpack_require__(2);
	
	var _numberWithCommas2 = _interopRequireDefault(_numberWithCommas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Candidate = function Candidate(_ref) {
	  var candidate = _ref.candidate,
	      raceCalled = _ref.raceCalled,
	      raceUncontested = _ref.raceUncontested,
	      totalVotes = _ref.totalVotes;
	
	  var pill = 'pill-circle pill--' + candidate.party.slice(0, 3);
	  var rowClass = 'candidate race__candidate-row' + (raceCalled && candidate.winner ? ' race__candidate-row--winner' : '');
	
	  return (0, _preact.h)(
	    'tr',
	    { className: rowClass },
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__party' },
	      (0, _preact.h)(
	        'span',
	        { className: pill },
	        candidate.party.slice(0, 1).toUpperCase()
	      )
	    ),
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__name' },
	      raceCalled && candidate.winner && '\u2713 ',
	      candidate.ballot_name,
	      ' ',
	      candidate.incumbent && (0, _preact.h)(
	        'span',
	        { 'class': 'pill pill--basic' },
	        'Incumbent'
	      )
	    ),
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__votes' },
	      raceUncontested ? '-' : (0, _numberWithCommas2.default)(candidate.votes)
	    ),
	    (0, _preact.h)(
	      'td',
	      { className: 'candidate__cell candidate__pct' },
	      raceUncontested ? '-' : (0, _formatPercent2.default)(candidate.votes, totalVotes),
	      (0, _preact.h)(
	        'span',
	        { className: 'candidate__pct-symbol' },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = Candidate;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _candidate = __webpack_require__(5);
	
	var _candidate2 = _interopRequireDefault(_candidate);
	
	var _countdown = __webpack_require__(4);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _mergeWriteIns = __webpack_require__(7);
	
	var _mergeWriteIns2 = _interopRequireDefault(_mergeWriteIns);
	
	var _numberWithCommas = __webpack_require__(2);
	
	var _numberWithCommas2 = _interopRequireDefault(_numberWithCommas);
	
	var _sortCandidates = __webpack_require__(10);
	
	var _sortCandidates2 = _interopRequireDefault(_sortCandidates);
	
	var _sumValues = __webpack_require__(3);
	
	var _sumValues2 = _interopRequireDefault(_sumValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Race = function (_Component) {
	  _inherits(Race, _Component);
	
	  function Race() {
	    _classCallCheck(this, Race);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Race.prototype.render = function render() {
	    var race = this.props.race;
	
	    if (!race) return null;
	
	    var isPresident = race.office_slug === 'us-president';
	    var isScoreboard = this.props.scoreboard;
	    var isOnHomepage = this.props.isOnHomepage;
	
	    var candidates = isPresident ? (0, _mergeWriteIns2.default)(race.candidates) : race.candidates;
	    var totalVotes = (0, _sumValues2.default)(candidates, 'votes');
	
	    var candidatesOutput = (0, _sortCandidates2.default)(candidates).map(function (candidate) {
	      return (0, _preact.h)(_candidate2.default, { raceCalled: race.called, raceUncontested: race.uncontested, totalVotes: totalVotes, candidate: candidate });
	    });
	
	    var precincts = (0, _numberWithCommas2.default)(race.precincts_reporting) + ' of ' + (0, _numberWithCommas2.default)(race.total_precincts) + ' precincts reporting (' + race.precincts_reporting_percent.toFixed(1) + '%)';
	
	    var countdown = null;
	
	    if (this.props.timeLeft) {
	      countdown = (0, _preact.h)(_countdown2.default, { timeLeft: this.props.timeLeft });
	    }
	
	    return (0, _preact.h)(
	      'div',
	      { className: 'widget' },
	      (0, _preact.h)(
	        'div',
	        { className: 'race' },
	        countdown,
	        (0, _preact.h)(
	          'table',
	          { className: 'race__candidates' },
	          (0, _preact.h)(
	            'caption',
	            null,
	            (0, _preact.h)(
	              'div',
	              { className: 'race__caption' },
	              (0, _preact.h)(
	                'p',
	                { className: 'race__title' },
	                !isOnHomepage && race.office + ' — ' + race.district_display
	              ),
	              isScoreboard && false && (0, _preact.h)(
	                'label',
	                { 'class': 'race__save' },
	                (0, _preact.h)('input', { 'class': 'race__save-input', type: 'checkbox', value: race.id }),
	                'Save race'
	              )
	            )
	          ),
	          (0, _preact.h)(
	            'thead',
	            null,
	            (0, _preact.h)(
	              'tr',
	              null,
	              (0, _preact.h)(
	                'th',
	                { className: 'race__candidate-header', colspan: '2' },
	                isOnHomepage && 'Presidential',
	                ' Candidate'
	              ),
	              (0, _preact.h)(
	                'th',
	                { className: 'race__candidate-header race__candidate-header--numeric' },
	                isPresident ? 'Votes in Texas' : 'Votes'
	              ),
	              (0, _preact.h)(
	                'th',
	                { className: 'race__candidate-header race__candidate-header--numeric' },
	                'Pct.',
	                (0, _preact.h)(
	                  'span',
	                  { className: 'candidate__pct-symbol' },
	                  '%'
	                )
	              )
	            )
	          ),
	          (0, _preact.h)(
	            'tbody',
	            null,
	            race.called && race.result !== 'not called' && (0, _preact.h)(
	              'tr',
	              { 'class': 'race__called-row' },
	              (0, _preact.h)(
	                'td',
	                { colspan: '4' },
	                race.result === 'uncontested' ? null : 'Projected',
	                ' ',
	                isPresident ? 'Texas ' + race.result : race.result
	              )
	            ),
	            candidatesOutput
	          )
	        ),
	        (0, _preact.h)(
	          'div',
	          { className: 'race__metrics' },
	          this.props.includeFullResultsButton ? (0, _preact.h)(
	            'a',
	            { className: 'button button--yellow', href: 'https://elections.texastribune.org/2016/general-election-results/' },
	            'View full election results \xBB'
	          ) : (0, _preact.h)('span', null),
	          (0, _preact.h)(
	            'p',
	            { className: 'race__precincts' },
	            race.uncontested ? 'No totals reported in uncontested races' : precincts
	          )
	        )
	      )
	    );
	  };
	
	  return Race;
	}(_preact.Component);
	
	exports.default = Race;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mergeWriteIns;
	
	var _sumValues = __webpack_require__(3);
	
	var _sumValues2 = _interopRequireDefault(_sumValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mergeWriteIns(candidates) {
	  var writeIns = candidates.filter(function (candidate) {
	    return candidate.party === 'writein';
	  });
	  var writeInsTotalVotes = (0, _sumValues2.default)(writeIns, 'votes');
	  var merged = candidates.filter(function (candidate) {
	    return candidate.party !== 'writein';
	  });
	
	  merged.push({
	    id: 9999,
	    ballot_name: 'Write-in candidates',
	    ballot_last_name: 'Write-ins',
	    incumbent: false,
	    winner: false,
	    votes: writeInsTotalVotes,
	    party: 'writein'
	  });
	
	  return merged;
	}

/***/ },
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* Tock by Mr Chimp - github.com/mrchimp/tock
	* Based on code by James Edwards:
	*    sitepoint.com/creating-accurate-timers-in-javascript/
	*/
	
	// Implements Date.now() for ie lt 9
	Date.now = Date.now || function() { return +new Date(); };
	
	// Polyfills Function.prototype.bind for IE lt 9 and Safari lt 5.1
	if ( typeof Function.prototype.bind != 'function' ) {
	    Function.prototype.bind = function (ctx) {
	        var args = Array.prototype.slice.call(arguments, 1),
	            fn = this;
	        return function () {
	            args.push.apply(args, arguments);
	            return fn.apply(ctx, args);
	        };
	    };
	}
	
	(function (root, factory) {
	  if ( true ) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof exports === 'object' ) {
	    module.exports = factory();
	  } else {
	    root.Tock = factory();
	  }
	}(this, function () {
	
	  /**
	   * Called every tick for countdown clocks.
	   * i.e. once every this.interval ms
	   */
	  function _tick () {
	    this.time += this.interval;
	
	    if ( this.countdown && (this.duration_ms - this.time < 0) ) {
	      this.final_time = 0;
	      this.go = false;
	      this.callback(this);
	      clearTimeout(this.timeout);
	      this.complete(this);
	      return;
	    } else {
	      this.callback(this);
	    }
	
	    var diff = (Date.now() - this.start_time) - this.time,
	        next_interval_in = diff > 0 ? this.interval - diff : this.interval;
	
	    if ( next_interval_in <= 0 ) {
	      this.missed_ticks = Math.floor(Math.abs(next_interval_in) / this.interval);
	      this.time += this.missed_ticks * this.interval;
	
	      if ( this.go ) {
	        _tick.call(this);
	      }
	    } else if ( this.go ) {
	      this.timeout = setTimeout(_tick.bind(this), next_interval_in);
	    }
	  }
	
	  /**
	   * Called by Tock internally - use start() instead
	   */
	  function _startCountdown (duration) {
	    this.duration_ms = duration;
	    this.start_time = Date.now();
	    this.time = 0;
	    this.go = true;
	    _tick.call(this);
	  }
	
	  /**
	   * Called by Tock internally - use start() instead
	   */
	  function _startTimer (start_offset) {
	    this.start_time = start_offset || Date.now();
	    this.time = 0;
	    this.go = true;
	    _tick.call(this);
	  }
	
	  var MILLISECONDS_RE           = /^\s*(\+|-)?\d+\s*$/,
	      MM_SS_RE                  = /^(\d{1,2}):(\d{2})$/,
	      MM_SS_ms_OR_HH_MM_SS_RE   = /^(\d{1,2}):(\d{2})(?::|\.)(\d{2,3})$/,
	      MS_PER_HOUR               = 3600000,
	      MS_PER_MIN                = 60000,
	      MS_PER_SEC                = 1000,
	      /* The RegExp below will match a date in format `yyyy-mm-dd HH:MM:SS` and optionally with `.ms` at the end.
	       * It will also match ISO date string, i.e. if the whitespace separator in the middle is replaced with a `T`
	       * and the date string is also suffixed with a `Z` denoting UTC timezone.
	       */
	      yyyy_mm_dd_HH_MM_SS_ms_RE = /^(\d{4})-([0-1]\d)-([0-3]\d)(?:\s|T)(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3})Z?)?$/;
	
	  var Tock = function (options) {
	    options = options || {};
	
	    if ( ! (this instanceof Tock) ) return new Tock(options);
	
	    Tock.instances = (Tock.instances || 0) + 1;
	
	    this.go           = false;
	    this.timeout      = null;
	    this.missed_ticks = null;
	    this.interval     = options.interval || 10;
	    this.countdown    = options.countdown || false;
	    this.start_time   = 0;
	    this.pause_time   = 0;
	    this.final_time   = 0;
	    this.duration_ms  = 0;
	    this.time         = 0;
	    this.callback     = options.callback || function () {};
	    this.complete     = options.complete || function () {};
	  };
	
	  /**
	   * Reset the clock
	   */
	  Tock.prototype.reset = function () {
	    if ( this.countdown ) {
	      return false;
	    }
	
	    this.stop();
	    this.start_time = 0;
	    this.time = 0;
	  };
	
	  /**
	   * Start the clock.
	   * @param {Various} time Accepts a single "time" argument
	   *   which can be in various forms:
	   *   - MM:SS
	   *   - MM:SS:ms or MM:SS.ms
	   *   - HH:MM:SS
	   *   - yyyy-mm-dd HH:MM:SS.ms
	   *   - milliseconds
	   */
	  Tock.prototype.start = function (time) {
	    if (this.go) return false;
	
	    time = time ? this.timeToMS(time) : 0;
	
	    this.start_time = time;
	    this.pause_time = 0;
	
	    if ( this.countdown ) {
	      _startCountdown.call(this, time);
	    } else {
	      _startTimer.call(this, Date.now() - time);
	    }
	  };
	
	  /**
	   * Stop the clock and clear the timeout
	   */
	  Tock.prototype.stop = function () {
	    this.pause_time = this.lap();
	    this.go = false;
	
	    clearTimeout(this.timeout);
	
	    if ( this.countdown ) {
	      this.final_time = this.duration_ms - this.time;
	    } else {
	      this.final_time = (Date.now() - this.start_time);
	    }
	  };
	
	  /**
	   * Stop/start the clock.
	   */
	  Tock.prototype.pause = function () {
	    if ( this.go ) {
	      this.pause_time = this.lap();
	      this.stop();
	    } else {
	      if ( this.pause_time ) {
	        if ( this.countdown ) {
	          _startCountdown.call(this, this.pause_time);
	        } else {
	          _startTimer.call(this, Date.now() - this.pause_time);
	        }
	
	        this.pause_time = 0;
	      }
	    }
	  };
	
	  /**
	   * Get the current clock time in ms.
	   * Use with Tock.msToTime() to make it look nice.
	   * @return {Integer} Number of milliseconds ellapsed/remaining
	   */
	  Tock.prototype.lap = function () {
	    if ( this.go ) {
	      var now;
	
	      if ( this.countdown ) {
	        now = this.duration_ms - (Date.now() - this.start_time);
	      } else {
	        now = (Date.now() - this.start_time);
	      }
	
	      return now;
	    }
	
	    return this.pause_time || this.final_time;
	  };
	
	  /**
	   * Format milliseconds as a MM:SS.ms string.
	   * @param  {Integer} ms Number of milliseconds
	   * @return {String}     String representation of ms in format MM:SS:ms
	   */
	  Tock.prototype.msToTime = function (ms) {
	    var milliseconds = this.zeroPad(ms % MS_PER_SEC, 3),
	        seconds = this.zeroPad(Math.floor((ms / MS_PER_SEC) % 60), 2),
	        minutes = this.zeroPad(Math.floor((ms / (MS_PER_MIN)) % 60), 2);
	
	    return minutes + ':' + seconds + '.' + milliseconds;
	  };
	
	  /**
	   * Pad the left side of a string with zeros up to a given length. I
	   * considered using an NPM package for this but it's probably best not to.
	   * @param  {Various} input  Number to pad. Will be converted to string.
	   * @param  {Integer} length Desired string length
	   * @return {String}         Padding number
	   */
	  Tock.prototype.zeroPad = function (input, length) {
	    input = input.toString();
	
	    while ( input.length < length ) {
	      input = '0' + input;
	    }
	
	    return input;
	  };
	
	  /**
	   * Format milliseconds as HH:MM:SS or HH:MM:SS:mmm
	   * @param  {Integer} ms      Number of milliseconds
	   * @param  {Boolean} show_ms If true, include milliseconds in output
	   * @return {String}          Formatted timecode string
	   */
	  Tock.prototype.msToTimecode = function (ms, show_ms) {
	    var seconds  = this.zeroPad(Math.floor((ms / MS_PER_SEC)  % 60), 2),
	        minutes  = this.zeroPad(Math.floor((ms / MS_PER_MIN)  % 60), 2),
	        hours    = this.zeroPad(Math.floor((ms / MS_PER_HOUR) % 60), 2),
	        millisec = (show_ms ? ':' + this.zeroPad(Math.floor(ms % MS_PER_SEC), 3) : '');
	
	    return hours + ':' + minutes + ':' + seconds + millisec;
	  };
	
	  /**
	   * Convert a time string to milliseconds
	   *
	   * Possible inputs:
	   * MM:SS
	   * MM:SS:ms or MM:SS.ms
	   * HH:MM:SS
	   * yyyy-mm-dd HH:MM:SS.ms
	   *
	   * A milliseconds input will return it back for safety
	   * If the input cannot be recognized then 0 is returned
	   */
	  Tock.prototype.timeToMS = function (time) {
	    // If input is milliseconds integer then return it back
	    if ( MILLISECONDS_RE.test(String(time)) ) {
	      return time;
	    }
	
	    var ms,
	        time_split,
	        match,
	        date,
	        now = new Date();
	
	    if ( MM_SS_RE.test(time) ) { // If MM:SS
	      time_split = time.split(':');
	      ms = parseInt(time_split[0], 10) * MS_PER_MIN;
	      ms += parseInt(time_split[1], 10) * MS_PER_SEC;
	    } else {
	      match = time.match(MM_SS_ms_OR_HH_MM_SS_RE);
	
	      if ( match ) {
	        if ( match[3].length == 3 || parseInt(match[3], 10) > 59 ) { // If MM:SS:ms or MM:SS.ms (e.g. 10:10:458 or 10:10.458)
	          ms = parseInt(match[1], 10) * MS_PER_MIN;
	          ms += parseInt(match[2], 10) * MS_PER_SEC;
	          ms += parseInt(match[3], 10);
	        } else { // Then it's HH:MM:SS
	          ms = parseInt(match[1], 10) * MS_PER_HOUR;
	          ms += parseInt(match[2], 10) * MS_PER_MIN;
	          ms += parseInt(match[3], 10) * MS_PER_SEC;
	        }
	      } else if ( yyyy_mm_dd_HH_MM_SS_ms_RE.test(time) ) { // If yyyy-mm-dd HH:MM:SS or yyyy-mm-dd HH:MM:SS.ms or yyyy-mm-ddTHH:MM:SS.msZ
	        date = new Date();
	        now = new Date();
	
	        match = time.match(yyyy_mm_dd_HH_MM_SS_ms_RE);
	
	        date.setYear(match[1]);
	        date.setMonth(match[2]);
	        date.setDate(match[3]);
	        date.setHours(match[4]);
	        date.setMinutes(match[5]);
	        date.setSeconds(match[6]);
	
	        if (typeof match[7] !== 'undefined') {
	          date.setMilliseconds(match[7]);
	        }
	
	        ms = Math.max(0, date.getTime() - now.getTime());
	      } else {
	        // Let's try it as a date string
	        now = new Date();
	        ms = Date.parse(time);
	
	        if ( !isNaN(ms) ) { // Looks ok
	          ms = Math.max(0, ms - now.getTime());
	        } else { // Could not recognize input, so start from 0
	          ms = 0;
	        }
	      }
	    }
	
	    return ms;
	  };
	
	  return Tock;
	}));


/***/ },
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _race = __webpack_require__(6);
	
	var _race2 = _interopRequireDefault(_race);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Results = function (_Component) {
	  _inherits(Results, _Component);
	
	  function Results() {
	    _classCallCheck(this, Results);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Results.prototype.render = function render() {
	    var _this2 = this;
	
	    var races = this.props.races;
	    var racesFilter = this.props.racesFilter;
	
	    var results = races;
	
	    if (racesFilter && racesFilter !== 'all' && racesFilter !== 'my-races') {
	      results = results.filter(function (race) {
	        return racesFilter === race.office_slug;
	      });
	    }
	
	    if (racesFilter === 'my-races') {
	      (function () {
	        var selected = _this2.base.querySelectorAll('.race__save-input:checked');
	
	        var ids = [];
	
	        for (var i = 0; i < selected.length; ++i) {
	          ids.push(+selected[i].value);
	        }
	
	        results = results.filter(function (race) {
	          return ids.indexOf(race.id) >= 0;
	        });
	      })();
	    }
	
	    results = results.map(function (race) {
	      return (0, _preact.h)(_race2.default, { scoreboard: _this2.props.scoreboard, key: race.id, race: race });
	    });
	
	    var klass = null;
	
	    if (this.props.scoreboard) {
	      klass = 'scoreboard';
	    }
	
	    return (0, _preact.h)(
	      'div',
	      { className: klass },
	      results
	    );
	  };
	
	  return Results;
	}(_preact.Component);
	
	exports.default = Results;

/***/ },
/* 17 */,
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getResults;
	/* global fetch */
	
	var resultsURL = 'https://s3.amazonaws.com/sos.texastribune.org/results/2016-general.json';
	
	function getResults() {
	  return fetch(resultsURL + '?__=' + +new Date()).then(function (res) {
	    return res.json();
	  });
	}

/***/ },
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = adLoader;
	/* global googletag */
	
	function adLoader() {
	  var gads = document.createElement('script');
	  gads.async = true;
	  gads.type = 'text/javascript';
	  var useSSL = document.location.protocol === 'https:';
	  gads.src = (useSSL ? 'https:' : 'http:') + '//www.googletagservices.com/tag/js/gpt.js';
	  var node = document.getElementsByTagName('script')[0];
	  node.parentNode.insertBefore(gads, node);
	
	  googletag.cmd.push(function () {
	    googletag.pubads().setTargeting('tribpedia', 'public-schools');
	
	    var bannerMapping = googletag.sizeMapping().addSize([768, 1], [728, 90]).addSize([0, 0], [300, 250]).build();
	
	    googletag.defineSlot('/5805113/TexasTribune_Data_DataPage_ATF_Header_Leaderboard_728x90', [728, 90], 'ad-banner-leader').defineSizeMapping(bannerMapping).addService(googletag.pubads());
	
	    googletag.defineSlot('/5805113/TexasTribune_Data_DataPage_BTF_Footer_Leaderboard_728x90', [728, 90], 'ad-banner-footer').defineSizeMapping(bannerMapping).addService(googletag.pubads());
	
	    googletag.pubads().enableSingleRequest();
	    googletag.enableServices();
	  });
	
	  googletag.cmd.push(function () {
	    googletag.display('ad-banner-leader');
	    googletag.display('ad-banner-footer');
	  });
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _tocktimer = __webpack_require__(13);
	
	var _tocktimer2 = _interopRequireDefault(_tocktimer);
	
	var _controlBar = __webpack_require__(23);
	
	var _controlBar2 = _interopRequireDefault(_controlBar);
	
	var _results = __webpack_require__(16);
	
	var _results2 = _interopRequireDefault(_results);
	
	var _getResults = __webpack_require__(18);
	
	var _getResults2 = _interopRequireDefault(_getResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      races: [],
	      racesFilter: 'all',
	      savedRaces: [],
	      timeLeft: 0
	    };
	
	    _this.onTick = _this.onTick.bind(_this);
	    _this.onComplete = _this.onComplete.bind(_this);
	    _this.onOfficeFilter = _this.onOfficeFilter.bind(_this);
	
	    _this.duration = 30 * 1000;
	
	    _this.timer = new _tocktimer2.default({
	      countdown: true,
	      interval: 1000,
	      callback: _this.onTick,
	      complete: _this.onComplete
	    });
	    return _this;
	  }
	
	  App.prototype.onTick = function onTick() {
	    var now = Math.ceil(this.timer.lap() / 1000);
	    this.setState({
	      timeLeft: now === 0 ? 'Updating!' : now
	    });
	  };
	
	  App.prototype.onComplete = function onComplete() {
	    this.fetchData();
	  };
	
	  App.prototype.fetchData = function fetchData() {
	    var _this2 = this;
	
	    (0, _getResults2.default)().then(function (races) {
	      _this2.setState({ races: races });
	      _this2.timer.start(_this2.duration);
	    });
	  };
	
	  App.prototype.componentDidMount = function componentDidMount() {
	    this.fetchData();
	  };
	
	  App.prototype.onOfficeFilter = function onOfficeFilter(value) {
	    this.setState({
	      racesFilter: value
	    });
	  };
	
	  App.prototype.render = function render() {
	    return (0, _preact.h)(
	      'div',
	      null,
	      (0, _preact.h)(_controlBar2.default, { onOfficeFilter: this.onOfficeFilter, timeLeft: this.state.timeLeft }),
	      (0, _preact.h)(_results2.default, { scoreboard: true, racesFilter: this.state.racesFilter, races: this.state.races })
	    );
	  };
	
	  return App;
	}(_preact.Component);
	
	exports.default = App;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	var _countdown = __webpack_require__(4);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _officeChooser = __webpack_require__(26);
	
	var _officeChooser2 = _interopRequireDefault(_officeChooser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import scrollWatcher from '../utils/scroll-watcher';
	
	var ControlBar = function (_Component) {
	  _inherits(ControlBar, _Component);
	
	  function ControlBar() {
	    _classCallCheck(this, ControlBar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  // constructor (props) {
	  //   super(props);
	  //
	  //   this.stickyBar = this.stickyBar.bind(this);
	  // }
	
	  // componentDidMount () {
	  //   scrollWatcher.add(this.stickyBar);
	  // }
	  //
	  // componentWillUnmount () {
	  //   scrollWatcher.remove(this.stickyBar);
	  // }
	
	  // stickyBar () {
	  //   console.log(this.base.getBoundingClientRect());
	  // }
	
	  ControlBar.prototype.render = function render() {
	    var timeLeft = this.props.timeLeft;
	
	    return (0, _preact.h)(
	      'div',
	      { className: 'control-bar' },
	      (0, _preact.h)(_officeChooser2.default, { onChange: this.props.onOfficeFilter }),
	      (0, _preact.h)(_countdown2.default, { noLine: true, timeLeft: timeLeft })
	    );
	  };
	
	  return ControlBar;
	}(_preact.Component);
	
	exports.default = ControlBar;

/***/ },
/* 24 */,
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _preact = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CUSTOMS = {
	  'all': 'View all'
	};
	
	var OFFICES = {
	  'us-president': 'U.S. President',
	  'us-house': 'U.S. House',
	  'tx-supreme-court': 'Texas Supreme Court',
	  'court-criminal-appeals': 'Court of Criminal Appeals',
	  'railroad-commission': 'Texas Railroad Commission',
	  'sboe': 'State Board of Education',
	  'tx-senate': 'Texas Senate',
	  'tx-house': 'Texas House'
	};
	
	var OfficeChooser = function (_Component) {
	  _inherits(OfficeChooser, _Component);
	
	  function OfficeChooser(props) {
	    _classCallCheck(this, OfficeChooser);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      value: 'all'
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  OfficeChooser.prototype.handleChange = function handleChange(e) {
	    var _this2 = this;
	
	    this.setState({
	      value: e.target.value
	    }, function () {
	      _this2.props.onChange(_this2.state.value);
	    });
	  };
	
	  OfficeChooser.prototype.render = function render() {
	    var customOptions = Object.keys(CUSTOMS).map(function (key) {
	      return (0, _preact.h)(
	        'option',
	        { value: key },
	        CUSTOMS[key]
	      );
	    });
	
	    var raceOptions = Object.keys(OFFICES).map(function (key) {
	      return (0, _preact.h)(
	        'option',
	        { value: key },
	        OFFICES[key]
	      );
	    });
	
	    return (0, _preact.h)(
	      'div',
	      { className: 'office-chooser' },
	      (0, _preact.h)(
	        'p',
	        { className: 'office-chooser__label' },
	        'Filter by race'
	      ),
	      (0, _preact.h)(
	        'select',
	        { className: 'office-chooser__select', value: this.state.value, onChange: this.handleChange },
	        customOptions,
	        (0, _preact.h)(
	          'optgroup',
	          { label: 'Filter by office' },
	          raceOptions
	        )
	      )
	    );
	  };
	
	  return OfficeChooser;
	}(_preact.Component);
	
	exports.default = OfficeChooser;

/***/ }
]);


// WEBPACK FOOTER //
// main.js